import { ARCHIVE_APPOINTMENT_URL } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default async function archiveAppointment({
    aid,
}: {
    aid: string;
}): Promise<{ success: boolean; error?: string }> {
    const response = await fetchWithRefresh(ARCHIVE_APPOINTMENT_URL(aid), {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            mode: 'cors',
            credentials: 'include',
        },
    });

    const res = await response.json();
    return res;
}
